import React from 'react'
import { Link } from 'react-router-dom';

function TourCard(props) {
    const { tourImage, tourTitle, tourPrice, tourID, tourSlug, tourType, tourDuration, tourNights, tourRating, tourReviewCount, tourDescription, tourFeatured, tourDifficulty } = props;
    
    // Function to handle image URL properly
    const getImageUrl = (imageUrl) => {
        if (!imageUrl) return '/assets/img/tour/tour_default.jpg';
        
        // If it's a full URL (starts with http/https), use it directly
        if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
            return imageUrl;
        }
        
        // If it starts with /media/, use it directly (Django media URL)
        if (imageUrl.startsWith('/media/')) {
            return imageUrl;
        }
        
        // Otherwise, prepend the assets path
        return `/assets/img/tour/${imageUrl}`;
    };
    
    return (
        <div className="tour-box th-ani">
            <div className="tour-box_img global-img">
                <img src={getImageUrl(tourImage)} alt={tourTitle || 'Tour'} />
            </div>
            <div className="tour-content">
                <h3 className="box-title">
                    <Link to={`/tour-details/${tourSlug || tourID}`}>{tourTitle || 'Greece Tour Package'}</Link>
                </h3>
                <div className="tour-rating">
                    <div
                        className="star-rating"
                        role="img"
                        aria-label={`Rated ${tourRating || 5.0} out of 5`}
                    >
                        <span style={{ width: `${((tourRating || 5.0) / 5) * 100}%` }}>
                            Rated
                            <strong className="rating">{tourRating || 5.0}</strong> out of 5
                            based on <span className="rating">{tourReviewCount || 0}</span> reviews
                        </span>
                    </div>
                    <Link
                        to={`/tour-details/${tourSlug || tourID}`}
                        className="woocommerce-review-link"
                    >
                        (<span className="count">{tourReviewCount || 0}</span> Reviews)
                    </Link>
                </div>
                <h4 className="tour-box_price">
                    <span className="currency">{tourPrice || '$980.00'}</span>/Person
                </h4>
                <div className="tour-action">
                    <span>
                        <i className="fa-light fa-clock" />
                        {tourDuration || 7} Days {tourNights ? `/ ${tourNights} Nights` : ''}
                    </span>
                    <Link to={`/tour-details/${tourSlug || tourID}`} className="th-btn style4">
                        Detail View
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default TourCard
